// The tenant's own data rights (ADR tenant-export-deletion-and-consent): taking a copy of
// everything it holds, and asking for all of it to be deleted. Both belong to the tenant's admins;
// for a personal tenant that is the person, who is its one TenantAdmin.
import { isRole } from '../policy/rules.js';
const tenantAdmin = isRole('TenantAdmin');
export const exportPolicy = {
    kind: 'export',
    scope: 'tenant',
    actions: { create: tenantAdmin, read: tenantAdmin },
};
export const deletionPolicy = {
    kind: 'deletion',
    scope: 'tenant',
    actions: { request: tenantAdmin, cancel: tenantAdmin },
};
//# sourceMappingURL=tenant-data.js.map